/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Sources_TranscriptInputs */



/**
* | output |
* | --- |
* | "transcript" |
*
* @param {Meeting_Report_Sources_TranscriptInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_sources_transcript = /** @type {((inputs?: Meeting_Report_Sources_TranscriptInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Sources_TranscriptInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("transcript")
	if (locale === "fr") return /** @type {LocalizedString} */ ("transcription")
	return /** @type {LocalizedString} */ ("transcript")
});